var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-notice main-section--xs"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('main-notice-list')], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('ul', {
    staticClass: "main-notice__scedule"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('v-card', {
      attrs: {
        "href": item.route,
        "target": "_blank",
        "img": item.image,
        "height": "100%",
        "tile": "",
        "flat": ""
      }
    }, [_c('v-card-title', [_vm._v(" " + _vm._s(item.title) + " ")]), _c('v-card-text', [_vm._v("재단실 신청하기"), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1);
  }), 0)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }